import { render, staticRenderFns } from "./InvitePatientModal.vue?vue&type=template&id=6141e200"
import script from "./InvitePatientModal.vue?vue&type=script&lang=js"
export * from "./InvitePatientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports